// Date display for the Companion. Two rules the rest of the UI must never break:
//   1. A date-only value ("2026-09-11") is a calendar date. It is shown as that
//      day in every timezone; it is never parsed as UTC midnight and shifted.
//   2. Missing, unparseable, or epoch-era values (before 2000) are "unknown".
//      A 1970 sentinel is never displayed as a date.

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const MIN_KNOWN = Date.UTC(2000, 0, 1);

export function parseDateValue(v) {
  if (v === null || v === undefined || v === '') return null;
  if (typeof v === 'number') { const d = new Date(v < 1e11 ? v * 1000 : v); return Number.isNaN(d.getTime()) ? null : d; }
  const s = String(v).trim();
  const m = s.match(DATE_ONLY);
  if (m) return { calendar: true, y: +m[1], mo: +m[2], d: +m[3] };
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function isKnownDate(v) {
  const p = parseDateValue(v);
  if (!p) return false;
  if (p.calendar) return p.y >= 2000;
  return p.getTime() >= MIN_KNOWN;
}

// "9/11/2026" style (locale), or '' when unknown.
export function formatDate(v, locale) {
  const p = parseDateValue(v);
  if (!p) return '';
  if (p.calendar) {
    if (p.y < 2000) return '';
    return new Date(p.y, p.mo - 1, p.d).toLocaleDateString(locale, { year: 'numeric', month: 'numeric', day: 'numeric' });
  }
  if (p.getTime() < MIN_KNOWN) return '';
  return p.toLocaleDateString(locale, { year: 'numeric', month: 'numeric', day: 'numeric' });
}

export function formatDateTime(v, locale) {
  const p = parseDateValue(v);
  if (!p) return '';
  if (p.calendar) return formatDate(v, locale);
  if (p.getTime() < MIN_KNOWN) return '';
  return p.toLocaleString(locale, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function formatTime(v, locale) {
  const p = parseDateValue(v);
  if (!p || p.calendar || p.getTime() < MIN_KNOWN) return '';
  return p.toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit' });
}
